// extracted by mini-css-extract-plugin
export default {"leaveGroupModal__overlay":"LeaveGroupModal_leaveGroupModal__overlay__osvZ8","modal":"LeaveGroupModal_modal__IJJOF","modal__btns":"LeaveGroupModal_modal__btns__TxwLU"};